export const accountBooking = {
  PARTICIPANT_TOGGLED: 'accountbooking.participant',
  TRANSPORT_SUMMARY_TOGGLED: 'accountbooking.transportSummary',
  CONTACT_INFO_TOGGLED: 'accountbooking.contactInfo',
  PAYMENT_BUTTON_PRESSED: 'accountbooking.paymentButton',
  DELETE_BOOKING_MODAL_OPEN: 'accountbooking.openDeleteBookingModalButton',
  BOOKING_DELETED: 'accountbooking.deleteBookingButton'
}
